import i18n from '../../language/index'
import {create_title} from '@/base/titleData'

export default {
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
    textAlign: 'left'
  },
  mb_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
    textAlign: 'center'
  },
  pc_widgets_infor: {
    title: create_title(i18n.t('widgets_basic_member_register_edit_2627')),
    moduleStyle: 1,
    img: 'https://staticjs.71360.com/static/txys-001/image/illustration/member_register_left.png',
    imgDefault: '',
    titleFont: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(30,30,30,1)',
        fontSeColor: 'rgba(30,30,30,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgb(0,120,215)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 12,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },
    labelFont: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(30,30,30,1)',
        fontSeColor: 'rgba(30,30,30,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 12,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },
    contentFont: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(30,30,30,1)',
        fontSeColor: 'rgba(30,30,30,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 12,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },
    background: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(247, 248, 251,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
    buttonBackground: {
      radio_val: 'default',
      default: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(48,120,208,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      },
      custom: {
        type: 'color', // 背景设置-类型
        img: '', // 背景设置-图片的URL
        color: 'rgba(255, 255, 255,1)', // 背景设置-颜色
        img_scale: 'scale_cover', //图片缩放 填充、等比例、平铺、拉伸、原图
        tile_effect: 'img_default', //平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
        background_size: 'cover',
        background_repeat: 'no-repeat',
        background_position: 'center center' //图片位置
      }
    },
    buttonFont: {
      radio_val: 'default',
      default: {
        fontSize: 16,
        fontWidth: 'normal',
        fontColor: 'rgba(255,255,255,1)',
        fontSeColor: 'rgba(255,255,255,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom: {
        fontSize: 12,
        fontWidth: 'normal',
        fontColor: 'rgba(50,50,50,1)',
        fontSeColor: 'rgba(50,50,50,1)',
        fontFamily: 'Arial',
        pattern: 'pure_color',
        fontStyle: '',
        fontWeight: 'normal',
        fontItalics: 'normal',
        fontUnderline: 'none',
        linear_gradient: {
          start_color: "rgba(0,120,215,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
    },
    buttonBorderRadius: {
      radio_val: 'default',
      default: {
        value: 0,
      },
      custom: {
        value: 0
      }
    },
  },
  mb_widgets_infor: {
    title: create_title(i18n.t('widgets_basic_member_register_edit_2627')),
    img: 'https://staticjs.71360.com/static/txys-001/image/illustration/member_register_mb@2x.png',
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  listArr: {
    title: i18n.t('widgets_basic_member_register_edit_2627'),
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_member_register/style.js